import React, { useState } from 'react';
import { supabase } from '../supabaseClient';

const IncomingOrderModal = ({ orders, onProcessOrder, onCloseAll }) => {
  const [processingId, setProcessingId] = useState(null);

  const updateStatus = async (orderId, status) => {
    setProcessingId(orderId);
    try {
      await supabase.from('orders').update({ status }).eq('id', orderId);
      // Tell parent to remove this specific order from the list
      onProcessOrder(orderId); 
    } catch (err) {
      console.error(err);
    } finally {
      setProcessingId(null);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/80 z-[100] flex items-center justify-center p-4 animate-fade-in">
      <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl overflow-hidden border-t-8 border-orange-500 max-h-[80vh] flex flex-col">
        
        {/* Header */}
        <div className="bg-gray-50 p-4 border-b border-gray-100 flex justify-between items-center">
          <h2 className="text-xl font-bold flex items-center gap-2 text-gray-900">
            🔔 {orders.length} New Order{orders.length > 1 ? 's' : ''}!
          </h2>
          <button onClick={onCloseAll} className="text-gray-400 hover:text-black font-bold text-sm">
            Minimize
          </button>
        </div>

        {/* Scrollable List */}
        <div className="overflow-y-auto p-4 space-y-4 bg-gray-100 flex-1">
          {orders.map((order) => (
            <div key={order.id} className="bg-white p-4 rounded-xl shadow-sm border border-gray-200 animate-slide-up">
              
              {/* Order Info */}
              <div className="flex justify-between items-start mb-3 border-b border-gray-100 pb-3">
                 <div>
                   <div className="flex items-center gap-2">
                     <span className="bg-orange-100 text-orange-600 px-2 py-0.5 rounded text-xs font-bold">#{order.id}</span>
                     <span className="text-xs text-gray-400">{new Date(order.created_at).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}</span>
                   </div>
                   <p className="text-lg font-bold text-gray-900 mt-1">
                     Table {order.table_number || 'N/A'}
                   </p>
                 </div>
                 <p className="text-xl font-bold text-orange-600">₹{order.total_price}</p>
              </div>

              {/* Items List */}
              <div className="space-y-1 mb-4">
                {order.items.map((item, i) => (
                  <div key={i} className="flex gap-2 text-sm text-gray-700">
                    <span className="font-bold text-gray-900">{item.quantity}x</span>
                    <span>{item.name}</span>
                  </div>
                ))}
              </div>

              {/* Action Buttons */}
              <div className="grid grid-cols-2 gap-3">
                <button 
                  onClick={() => updateStatus(order.id, 'Rejected')}
                  disabled={processingId === order.id}
                  className="py-2.5 bg-white border border-red-200 text-red-600 font-bold rounded-lg hover:bg-red-50 text-sm transition-colors"
                >
                  Reject
                </button>
                <button 
                  onClick={() => updateStatus(order.id, 'Accepted')}
                  disabled={processingId === order.id}
                  className="py-2.5 bg-green-500 text-white font-bold rounded-lg hover:bg-green-600 shadow-md shadow-green-200 text-sm transition-colors flex justify-center items-center"
                >
                  {processingId === order.id ? <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div> : '✅ Accept'}
                </button>
              </div>

            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default IncomingOrderModal;